import { useEffect, useState } from "react";
import { LogoMark } from "./LogoMark";

const links = [
  { label: "Experience", href: "#features" },
  { label: "About", href: "#about" },
  { label: "Scripture", href: "#scripture" },
  { label: "Voices", href: "#testimonials" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ease-lux ${
        scrolled
          ? "backdrop-blur-xl bg-evergreen/80 border-b border-gold/20 py-3"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3 group">
          <LogoMark className="h-11 w-11 transition-transform duration-500 ease-lux group-hover:scale-105" />
          <span className="font-serif text-2xl tracking-tight text-ivory">GodTended</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="relative text-sm font-medium tracking-wide text-champagne/80 transition-colors duration-300 hover:text-gold after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-gold after:transition-all after:duration-500 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#waitlist"
          data-testid="header-waitlist-cta"
          className="rounded-full border border-gold px-6 py-2.5 text-sm font-medium text-ivory transition-all duration-500 ease-lux hover:bg-gold hover:text-evergreen hover:-translate-y-0.5"
        >
          Join the Waiting List
        </a>
      </div>
    </header>
  );
};
